import ConfirmationPromotion from './ConfirmationPromotion.component';
export default ConfirmationPromotion;